import React from "react";
import { Button } from "@mui/material";
import { DataCardShell } from "../../../../components/responsive";
import Helpers from "../../../../components/Helpers";
import {
  ticketAssignedLabel,
  ticketPostedBy,
  ticketPriorityStyle,
  ticketStatusStyle,
} from "../ticketDisplay";

export function TicketCard({
  row,
  onOpenMessages,
  onAssign,
  onReassign,
  onDelete,
  onStatusChange,
}: {
  row: any;
  onOpenMessages: (row: any) => void;
  onAssign: (row: any) => void;
  onReassign: (row: any) => void;
  onDelete: (row: any) => void;
  onStatusChange: (id: number, status: string) => void;
}) {
  const assigned = ticketAssignedLabel(row);

  return (
    <DataCardShell
      title={row.ticketNumber || "Ticket"}
      subtitle={[
        row.createdAt
          ? Helpers.convertUtcToTimezone(row.createdAt, "M/D/YYYY")
          : null,
        row.category || null,
        ticketPostedBy(row),
      ]
        .filter(Boolean)
        .join(" · ")}
      chips={
        <>
          {row.priority ? (
            <select
              className="form-select form-select-sm text-white"
              value={row.priority || "LOW"}
              disabled
              style={{ ...ticketPriorityStyle(row.priority), width: 110 }}
            >
              <option value="LOW">Low</option>
              <option value="MEDIUM">Medium</option>
              <option value="HIGH">High</option>
            </select>
          ) : null}
          <select
            className="form-select form-select-sm text-white"
            style={{ ...ticketStatusStyle(row.status), width: 130 }}
            value={row.status}
            onChange={(e) => onStatusChange(row.id, e.target.value)}
          >
            <option value="NEW">New</option>
            <option value="INPROGRESS">In Progress</option>
            <option value="CLOSED">Closed</option>
          </select>
        </>
      }
      fields={[
        {
          label: "Subject",
          value: (
            <span
              className="subjectTicket"
              onClick={() => onOpenMessages(row)}
              style={{ cursor: "pointer" }}
            >
              {row.subject || "—"}
            </span>
          ),
        },
        { label: "Message", value: row.message || "—" },
        {
          label: "Email",
          value: row.email ? (
            <a href={`mailto:${row.email}`}>{row.email}</a>
          ) : (
            "—"
          ),
        },
        { label: "Phone", value: row.mobile || "—" },
        {
          label: "Assigned To",
          value: assigned ? (
            <span
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => onOpenMessages(row)}
            >
              {assigned}
            </span>
          ) : (
            "Unassigned"
          ),
        },
      ]}
      primaryAction={
        assigned ? (
          <Button size="small" variant="outlined" onClick={() => onReassign(row)}>
            Re-assign
          </Button>
        ) : (
          <Button size="small" variant="outlined" onClick={() => onAssign(row)}>
            Assign
          </Button>
        )
      }
      secondaryActions={
        <Button size="small" color="error" variant="outlined" onClick={() => onDelete(row)}>
          Delete
        </Button>
      }
    />
  );
}
